module.exports = __webpack_public_path__ + "img/time.7cdf3bd3.svg";